module.exports = __webpack_public_path__ + "static/media/Amherst_logo.28b685f0.JPG";